<button
  *ngIf="options.closeButton"
  (click)="remove()"
  class="toast-close-button"
  aria-label="Close"
>
  <span aria-hidden="true">&times;</span>
</button>
<div *ngIf="title" [class]="options.titleClass" [attr.aria-label]="title">
  {{ title }} <ng-container *ngIf="toastCount > 1">[{{ toastCount }}]</ng-container>
</div>
<div
  class="chat-media-container"
  *ngIf="chatMessage?.twilio?.type === 'media' && chatMessage?.mediaSource"
>
  <img class="chatMedia" mat-card-image square [src]="chatMessage.mediaSource" />
</div>
<div
  *ngIf="message && options.enableHtml"
  role="alertdialog"
  aria-live="polite"
  [class]="options.messageClass"
  [innerHTML]="message"
>
  <p [innerHTML]="message"></p>
</div>
<div
  *ngIf="message && !options.enableHtml"
  role="alertdialog"
  aria-live="polite"
  [class]="options.messageClass"
  [attr.aria-label]="message"
>
  <div
    class="chat-media-container"
    *ngIf="chatMessage?.twilio?.type === 'media' && chatMessage?.mediaSource"
  >
    <img class="chatMedia" mat-card-image square [src]="chatMessage.mediaSource" />
  </div>
  {{ message }}
</div>
<div class="toastActions">
  <sn-icon-button
    [matMenuTriggerFor]="snoozeMenu"
    matTooltip="Snooze notifications from {{ title }}"
    (click)="$event.stopPropagation()"
  >
    <sn-icon size="sm">notifications_paused</sn-icon>
  </sn-icon-button>
  <mat-menu #snoozeMenu="matMenu">
    <button mat-menu-item (click)="setSnooze(10)">
      <span>10 mins</span>
    </button>
    <button mat-menu-item (click)="setSnooze(20)">
      <span>20 mins</span>
    </button>
    <button mat-menu-item (click)="setSnooze(30)">
      <span>30 mins</span>
    </button>
  </mat-menu>
  <sn-icon-button (click)="popout()" matTooltip="Open channel in a new tab">
    <sn-icon size="sm">open_in_new</sn-icon>
  </sn-icon-button>
</div>
<div *ngIf="options.progressBar">
  <div
    class="toast-progress"
    [style.width]="width + '%'"
    [class.chatWarning]="width <= 50"
    [class.chatDanger]="width <= 30"
  ></div>
</div>
